var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_myaccount_24px-default",
    "data-name": "icon/myaccount_24px-default",
    transform: "translate(0 0.052)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundry",
    width: 24,
    height: 24,
    transform: "translate(0 -0.052)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "profile",
    transform: "translate(2.25 1.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M15.9,16.754a9.194,9.194,0,0,0-11.4,0A9.194,9.194,0,0,0,15.9,16.754Z",
    transform: "translate(-0.102 0.121)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M16.634,15.671a8.317,8.317,0,0,0-.605-12.022A8.974,8.974,0,0,0,3.62,4.235a8.2,8.2,0,0,0,0,11.435A10.2,10.2,0,0,1,16.634,15.671Z",
    transform: "translate(-0.029 -0.03)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M10.049.1A10.054,10.054,0,0,0,0,10.1a9.685,9.685,0,0,0,2.613,6.7l.9.9a9.953,9.953,0,0,0,12.964,0l.9-.9A9.685,9.685,0,0,0,20,10.1,9.9,9.9,0,0,0,10.049.1Zm0,18.7a8.526,8.526,0,0,1-5.527-2,8.693,8.693,0,0,1,11.155,0A9,9,0,0,1,10.049,18.8ZM16.582,16A9.953,9.953,0,0,0,3.618,16a8.668,8.668,0,0,1,.6-12.3,8.772,8.772,0,0,1,12.361.6,8.492,8.492,0,0,1,2.311,5.8A9.593,9.593,0,0,1,16.582,16Z",
    transform: "translate(0 0)",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M9.932,5.8A2.88,2.88,0,0,0,7,8.732a3.03,3.03,0,0,0,6.06,0A3.049,3.049,0,0,0,9.932,5.8Zm0,4.691a1.759,1.759,0,1,1,1.759-1.759h0A1.752,1.752,0,0,1,9.932,10.491Z",
    transform: "translate(0.122 0.057)",
    fill: "#3bb0ff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.a4134bb1f5d222ee60b6f6f53b252228.svg";
export { ForwardRef as ReactComponent };